<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiCommunity",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
